/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "정보";
var Access = "액세스";
var Account = "계정";
var Actions = "조치";
var Active = "활성";
var Add = "추가";
var Address = "주소";
var Advanced = "고급";
var Aliases = "별명";
var all = "모두";
var All = "모두";
var Apply = "적용";
var April = "4월";
var Arbitrary = "임의";
var Assign = "지정";
var August = "8월";
var Back = "뒤로";
var Basic = "기본";
var BNPP_EU = "BNPP_EU";
var Cancel = "취소";
var Category = "범주";
var Classic = "클래식";
var Clear = "지우기";
var CLI = "CLI";
var Close = "닫기";
var Clusters = "클러스터";
var code = "코드";
var Complete = "완료";
var Completed = "완료됨";
var Compliance = "규제 준수";
var Compliant = "준수";
var Configuration = "구성";
var Configure = "구성";
var Confirm = "확인";
var Connect = "연결";
var Connected = "연결됨";
var Connecting = "연결 중";
var Containers = "컨테이너";
var Country = "국가";
var Create = "작성";
var Created = "작성 날짜";
var Creating = "Creating";
var Critical = "위험";
var Current = "현재";
var Custom = "사용자 정의";
var Dallas = "Dallas";
var Datacenter = "데이터 센터";
var Datacenters = "데이터 센터";
var December = "12월";
var Delete = "삭제";
var Deleting = "Deleting";
var Deploying = "배치 중";
var Disabled = "사용 안함";
var Disconnect = "연결 끊기";
var Docs = "문서";
var Documentation = "문서";
var Done = "완료";
var Download = "다운로드";
var Draft = "드래프트";
var Edit = "편집";
var Enabled = "사용";
var Encryption = "암호화";
var End = "종료";
var Enterprise = "Enterprise";
var Establish = "설정";
var Expired = "만료됨";
var Failed = "실패";
var February = "2월";
var Filter = "필터";
var Filters = "필터";
var Finalizing = "완성";
var Frankfurt = "프랑크푸르트";
var Free = "무료";
var Friday = "금요일";
var Geography = "지리적 위치";
var Help = "도움말";
var hour = "hour";
var Hour = "시";
var hr = "시간";
var IAM = "IAM";
var ID = "ID";
var Images = "이미지";
var Inactive = "비활성";
var Incomplete = "불완전";
var Information = "정보";
var Infrastructure = "인프라";
var Instance = "인스턴스";
var Instances = "인스턴스";
var Integrations = "통합";
var Invalid = "올바르지 않음";
var January = "1월";
var July = "7월";
var June = "6월";
var Key = "키";
var Launch = "시작";
var Lite = "Lite";
var Loading = "로드 중";
var Location = "위치";
var Locations = "위치";
var Logging = "로깅";
var London = "런던";
var March = "3월";
var May = "5월";
var Metro = "메트로";
var Minute = "분";
var mo = "월";
var Monday = "월요일";
var Monitoring = "모니터링";
var Month = "월";
var more = "자세히 보기";
var Name = "이름";
var Namespace = "네임스페이스";
var Namespaces = "네임스페이스";
var Next = "다음";
var No = "아니오";
var None = "없음";
var Normal = "정규";
var Note = "참고";
var Notification = "알림";
var November = "11월";
var Objects = "오브젝트";
var October = "10월";
var Off = "해제";
var OK = "OK";
var On = "켜기";
var Open = "열기";
var Osaka = "오사카";
var Overview = "개요";
var Packages = "패키지";
var Pattern = "패턴";
var Pending = "보류 중";
var Plan = "계획";
var Premium = "Premium";
var Previous = "이전";
var Product = "제품";
var Products = "제품";
var Project = "프로젝트";
var Projects = "프로젝트";
var Property = "특성";
var provided = "제공됨";
var Provider = "제공자";
var Provisioning = "프로비저닝";
var Ready = "준비";
var Refresh = "새로 고치기";
var region = "지역";
var Region = "지역";
var Remove = "제거";
var Renew = "갱신";
var Repositories = "저장소";
var Requested = "요청됨";
var Required = "필수";
var Reservations = "예약";
var Reset = "재설정";
var resources = "리소스";
var Resources = "자원";
var Results = "결과";
var Review = "검토";
var Routing = "라우팅";
var Satellite = "Satellite";
var Saturday = "토요일";
var Save = "저장";
var Scanning = "스캐닝";
var Schedule = "스케줄";
var Search = "검색";
var Secret = "시크릿";
var Select = "선택";
var Sending = "보내는 중";
var September = "9월";
var Serverless = "서버리스";
var Service = "Service";
var Settings = "설정";
var Size = "크기";
var Sort = "정렬";
var Source = "소스";
var Start = "시작";
var State = "상태";
var Status = "상태";
var Storage = "스토리지";
var Submit = "제출";
var Subscription = "구독";
var Success = "성공";
var Summary = "요약";
var Sunday = "일요일";
var Sydney = "시드니";
var tag = "태그";
var tags = "태그";
var Tags = "태그";
var Thursday = "목요일";
var Tokyo = "도쿄";
var Topics = "토픽";
var Toronto = "토론토";
var Total = "총계";
var Trash = "휴지통";
var Trial = "평가판";
var Tuesday = "화요일";
var Unknown = "알 수 없음";
var Unsupported = "지원되지 않음";
var Update = "업데이트";
var Upgrade = "업그레이드";
var Value = "값";
var Values = "값";
var Version = "버전";
var View = "보기";
var Warning = "경고";
var Wednesday = "수요일";
var Workloads = "워크로드";
var Yes = "예";
var Zone = "구역";
var Zones = "구역";
var ko = {
	"'{{namespace}}' already exists. Enter another name.": "'{{namespace}}'이(가) 이미 존재합니다. 다른 이름을 입력하십시오.",
	"'Day of week' matches in addition to 'Day of month'": "'일자' 외에 '요일' 일치",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "'요일'은 '일자' 외에도 일치합니다. 이 표현식은 매일을 트리거됩니다.",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "{{count}}개의 항목이 선택됨",
	"{{count}} resources": "{{count}}개 리소스",
	"{{count}} resources included": "{{count}}개의 리소스가 포함됨",
	"{{current}} of {{total}} pages": "{{current}} / {{total}} 페이지",
	"{{datahookName}} response": "{{datahookName}} 응답",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "{{label}} 패턴",
	"{{min}}–{{max}} items": "{{min}} – {{max}}개의 항목",
	"{{min}}–{{max}} of {{total}} items": "{{min}} – {{max}} / {total}}개의 항목",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} 모듈, {{resourcesCount}}개의 자원",
	"{{name}} requires the following option(s) in order to deploy.": "배치하려면 {{name}}에는 다음 옵션이 필요합니다.",
	"{{price}} per {{unit}}": "{{unit}}당 {{price}}",
	"{{price}} per month": "월별 {{price}}",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/월",
	"{{resourcesCount}} resources": "{{resourcesCount}}개의 리소스",
	"{{rolesCount}} Role": "{{rolesCount}}개 역할",
	"{{rolesCount}} Roles": "{{rolesCount}}개 역할",
	"{{topicsCount}} topic active for this instance.": "이 인스턴스에 대해 {{topicsCount}}개의 주제가 활성화되어 있습니다.",
	"{{topicsCount}} topics active for this instance.": "이 인스턴스에 대해 {{topicsCount}}개의 주제가 활성화되어 있습니다.",
	"{{value}} percent status progress": "{{value}} 백분율 상태 진행",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}}(새 클러스터를 작성하여 이 베타 버전 사용해 보기)",
	"{{version}} (update to an earlier version first)": "{{version}}(먼저 이전 버전으로 업데이트)",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>Satellite 위치를 작성하려면 Cloud Object Storage 인스턴스가 있어야 합니다.</span> <a>자세히 보기</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00/인스턴스",
	"1 item selected": "1개의 항목이 선택됨",
	"1 of 1 page": "1/1 페이지",
	"1 role": "1개의 역할",
	"1–1 of 1 item": "1–1/1개 항목",
	"A collection of keys that belong to your service instance.": "서비스 인스턴스에 속하는 키 콜렉션입니다.",
	"A key can only have 5 aliases.": "키에는 별명을 5개만 사용할 수 있습니다.",
	"A Key Protect key": "Key Protect 키",
	"A location name is required. ": "위치 이름은 필수입니다. ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "멀티테넌트 키 관리 서비스입니다. 애플리케이션의 데이터를 암호화하고 데이터에 대한 액세스를 제어하기 위해 암호화 키를 작성하고 관리합니다.",
	"A name is required.": "이름이 필요합니다.",
	"A rotation policy of 12 months is recommended": "12개월의 회전 정책을 권장함",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "암호화 키를 연관시키려면 {{sourceServiceDisplayName}}과(와) {{serviceDisplayName}} 사이에 서비스 대 서비스 인증이 필요합니다. Key Protect가 사용자의 동의를 얻어 하나를 작성합니다. 또는 사용자가 수동으로 작성할 수도 있습니다.",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "단일 테넌트 키 관리 서비스입니다. 고객이 제어하는 전용 하드웨어 보안 모듈에서 제공하는 키 보관을 통해 암호화 키를 작성하고 관리합니다. ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "태그에는 영숫자 문자, 공백, 밑줄, 대시, 마침표 및 하나의 콜론만 포함될 수 있습니다.",
	"A tag cannot end with a colon.": "태그는 콜론으로 끝날 수 없습니다.",
	"A tag cannot include more than 128 characters.": "태그는 128자 이하여야 합니다.",
	"A tag cannot start with a colon.": "태그는 콜론으로 시작할 수 없습니다.",
	"A tag should not have spaces around a colon.": "태그는 콜론 주위에 공백이 있으면 안 됩니다.",
	About: About,
	Access: Access,
	"Access management tags": "액세스 관리 태그",
	"Access management tags (optional)": "액세스 관리 태그(옵션)",
	"Access management tags help you apply flexible access policies on specific resources.": "액세스 관리 태그는 특정 리소스에 대해 유연한 액세스 정책을 적용하는 데 도움을 줍니다.",
	Account: Account,
	"Account type": "계정 유형",
	"Action required": "조치 필요",
	Actions: Actions,
	Active: Active,
	"Active promotions": "활성 프로모션",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "이 리소스에 대해 Activity Tracker 이벤트 콜렉션이 사용으로 설정되어 있으며 라우팅 구성에 정의된 대로 대상에 전송됩니다.",
	"Activity tracker events": "활동 트래커 이벤트",
	"Activity tracking": "활동 추적",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "사용자의 특정 네임스페이스 목록에 단일 네임스페이스 또는 여러 개의 네임스페이스를 추가하십시오.",
	"Add a single project or multiple projects to your specific project's list.": "사용자의 특정 프로젝트 목록에 단일 프로젝트 또는 여러 개의 프로젝트를 추가하십시오.",
	"Add Activity tracker event collection": "Activity Tracker 이벤트 콜렉션 추가",
	"Add activity tracking": "활동 추적 추가",
	"Add event collection": "이벤트 콜렉션 추가",
	"Add hosts": "호스트 추가",
	"Add hosts to meet the minimum service requirements.": "최소 서비스 요구사항을 충족하려면 호스트를 추가하십시오.",
	"Add key alias (optional)": "키 별명 추가(선택사항)",
	"Add key description (optional)": "키 설명 추가(선택사항)",
	"Add logging": "로깅 추가",
	"Add monitoring": "모니터링 추가",
	"Add namespace": "네임스페이스 추가",
	"Add New": "새로 추가",
	"Add project": "프로젝트 추가",
	"Add storage": "스토리지 추가",
	"Add tags": "태그 추가",
	"Add to estimate": "추정에 추가",
	"Add to existing": "기존 항목에 추가",
	"Add to project": "프로젝트에 추가",
	"Adding ...": "추가 중...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "서비스를 프로비저닝하려면 아래의 필수 조치를 수행하십시오. 지금 또는 서비스를 작성한 후에 이러한 단계를 완료할 수 있습니다.",
	"Address field": "주소 필드",
	Advanced: Advanced,
	"Advanced options": "고급 옵션",
	"After connection": "연결 후",
	"After the service cluster is created, assign storage to the cluster.": "서비스 클러스터가 작성되고 나면 클러스터에 스토리지를 지정하십시오.",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "Event Notifications 연결을 끊으면 {{serviceName}} 인스턴스가 Event Notifications 인스턴스의 소스 서비스 목록에서 제거됩니다.",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "별명은 영숫자와 -_만 포함할 수 있습니다.",
	"Aliases must be at least 2 characters and at most 90 characters.": "별명은 최소 2자, 최대 90자여야 합니다.",
	all: all,
	All: All,
	"All audit events (default target)": "모든 감사 이벤트(기본 대상)",
	"All audit events from your account will be sent to a new instance": "계정의 모든 감사 이벤트가 새 인스턴스로 전송됨",
	"All audit events from your account will be sent to an existing instance": "계정의 모든 감사 이벤트는 기존 인스턴스로 전송됨",
	"All namespaces": "모든 네임스페이스",
	"All namespaces not supported": "모든 네임스페이스가 지원되지 않음",
	"All platform logs": "모든 플랫폼 로그",
	"All prerequisite services are installed on the location.": "모든 전제조건 서비스가 해당 위치에 설치되어 있습니다.",
	"All projects": "모든 프로젝트",
	"All projects not supported": "모든 프로젝트가 지원되지 않음",
	"All regions": "모든 지역",
	"All resource groups": "모든 리소스 그룹",
	"All secret groups": "모든 시크릿 그룹",
	"All types": "모든 유형",
	"All zone names must be unique": "모든 구역 이름은 고유해야 함",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "{{roleName}} 역할에 허용된 조치 수({{actionCount}})",
	"Already have an account? <a>Log in</a>": "이미 계정이 있으십니까? <a>로그인</a>",
	"An error occurred when fetching secrets. Try again later.": "시크릿을 페치하는 중에 오류가 발생했습니다. 나중에 다시 시도하십시오.",
	"An instance of Event Notifications <a>Create new instance</a>": "Event Notifications의 인스턴스 <a>새 인스턴스 작성</a>",
	"An unexpected error occurred.": "예상치 않은 오류가 발생했습니다.",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "문제를 신속하게 해결하고 사전적 가동 중지 시간을 방지하기 위해 로그를 분석하고 관리하십시오. <a>자세히 알아보기</a>",
	Apply: Apply,
	"Apply a code": "코드 적용",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "\"{{serviceName}}\" 인스턴스에서 {{ENInstanceName}}\" 인스턴스의 연결을 해제하시겠습니까?",
	"Are you sure you want to close the side panel?": "사이드 패널을 닫으시겠습니까?",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "이 패널을 닫으시겠습니까? 선택한 항목은 모두 손실됩니다.",
	"Are you sure?": "계속하시겠습니까?",
	Assign: Assign,
	"Associate key": "키 연관",
	"Attachment name": "첨부 이름",
	"Audit event collection is already enabled for this resource": "이 리소스에 대해 감사 이벤트 수집이 이미 사용 설정되어 있음",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "최적의 문제 해결과 가동 중지 시간 감소를 위해 감사 이벤트 콜렉션을 권장합니다.",
	"Audit events (error)": "이벤트 감사(오류)",
	"Audit events from {{region}} will be sent to a new instance": "{{region}}의 감사 이벤트가 새 인스턴스로 전송됨",
	"Audit events from {{region}} will be sent to an existing instance": "{{region}}의 감사 이벤트가 기존 인스턴스로 전송됨",
	"Audit events in {{region}}": "{{region}}의 감사 이벤트",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "감사 이벤트는 정의된 라우팅 범위에 따라 활성화된 IBM Cloud 서비스에서 수집됩니다.",
	"Audit events...": "감사 이벤트...",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "인증이 필요하거나 이 조치를 수행할 수 있는 올바른 권한이 없습니다.",
	"Authorization error": "권한 오류",
	"Authorization met": "권한 충족됨",
	"Authorization needed": "권한이 필요함",
	"Authorize now": "지금 권한 부여",
	"Authorizing...": "권한 부여 중...",
	Back: Back,
	"Base URI": "기본 URI",
	"Base64 encoded key material": "Base64 인코딩된 키 자료",
	Basic: Basic,
	"Before you begin": "시작하기 전에",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "프로젝트가 구성의 유효성을 검증하거나 배치하기 전에 이 계정에서 프로젝트 서비스를 권한 부여하여 Schematics, Catalog Management, Secrets Manager 및 Resource Controller와 통신해야 합니다. 해당 서비스에 대한 필수 액세스 권한이 있는 사용자는 이 계정에 프로젝트를 작성하여 권한을 자동으로 부여하거나 수동으로 서비스 권한 부여에 대한 서비스를 작성할 수 있습니다. 이 권한 부여는 한 번만 필요합니다.",
	"Billing information": "청구 정보",
	"Billing period": "청구 기간",
	BNPP_EU: BNPP_EU,
	"Bucket name": "버킷 이름",
	"By {{name}}": "{{name}}",
	"By clicking Save, you are creating the following access:": "저장을 클릭하면 다음 액세스가 작성됩니다.",
	"Can't retrieve details": "세부사항을 검색할 수 없습니다.",
	Cancel: Cancel,
	"Cannot list integrations!": "통합을 나열할 수 없습니다!",
	"Cannot view keys in this instance": "이 인스턴스에서는 키를 볼 수 없음",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "비용이 적용됩니다. <a>자세히 알아보기</a>",
	"Choose a cluster version": "클러스터 버전 선택",
	"Choose a key ring": "키 링 선택",
	"Choose a resource group": "리소스 그룹 선택",
	"Choose account...": "계정 선택...",
	"Choose an existing HPCS instance.": "기존 HPCS 인스턴스를 선택하십시오.",
	"Choose an existing Key Protect instance.": "기존 Key Protect 인스턴스를 선택하십시오.",
	"Choose an instance": "인스턴스 선택",
	"Choose an option": "옵션 선택",
	"Choose category...": "카테고리 선택...",
	"Choose location": "위치 선택",
	"Choose plan": "계획 선택",
	"Choose property...": "특성 선택...",
	"Choose provider...": "제공자 선택...",
	"Choose secret...": "시크릿 선택...",
	"Choose service instance...": "서비스 인스턴스 선택...",
	"Choose source name...": "소스 이름 선택...",
	"Choose source...": "소스 선택...",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "IBM Cloud에서 사용 가능한 서비스 인스턴스의 플랫폼 메트릭을 수신할 IBM Cloud Monitoring 인스턴스를 선택하십시오.",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "IBM Cloud에서 사용 가능한 서비스 인스턴스의 플랫폼 로그를 수신할 IBM Cloud Analysis 인스턴스를 선택하십시오.",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "모두 지우기",
	"Clear all selected items": "모든 선택된 항목 취소",
	"Clear filters": "필터 지우기",
	"Clear selected": "지우기가 선택됨",
	"Clear selected item": "선택된 항목 취소",
	"Clear selection": "선택 해제",
	CLI: CLI,
	Close: Close,
	"Close menu": "메뉴 닫기",
	"Close page navigation menu": "페이지 탐색 메뉴 닫기",
	"Close Panel": "패널 닫기",
	"Close Push Panel": "푸시 패널 닫기",
	"Closing side panel": "사이드 패널 닫기",
	"Cloud Logs": "클라우드 로그",
	"Cloud Logs instance": "클라우드 로그 인스턴스",
	"Cloud Logs instance name": "클라우드 로그 인스턴스 이름",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Cloud Object Storage 인스턴스",
	"Cluster \"{{name}}\" is being deleted.": "클러스터 \"{{name}}\"을(를) 삭제하고 있습니다.",
	"Cluster management": "클러스터 관리",
	"Cluster version": "클러스터 버전",
	"Cluster version cannot be updated.": "클러스터 버전을 업데이트할 수 없습니다.",
	Clusters: Clusters,
	code: code,
	"Code sample": "코드 샘플",
	"Collapse all rows": "행 모두 접기",
	"Collapse group": "그룹 접기",
	"Collapse row": "행 접기",
	"Collapse summary": "요약 접기",
	"Compact (24px)": "최소(24픽셀)",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "구성 세부사항",
	"Configuration name": "구성 이름",
	Configure: Configure,
	"Configure activity tracking": "활동 추적 구성",
	"Configure encryption": "암호화 구성",
	"Configure logging": "로깅 구성",
	"Configure monitoring": "모니터링 구성",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "Event Notifications에 연결",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "{{serviceName}} 인스턴스를 기존 Event Notifications 인스턴스에 연결하십시오.",
	Connected: Connected,
	"Connected instance": "연결된 인스턴스",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "Event Notifications의 연결된 인스턴스가 존재하지 않습니다. 관리자에게 문의하십시오.",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "Key Protect를 프로비저닝하기 위한 플랜에 액세스하려면 계정 관리자에게 문의하십시오.",
	"Contact your account administrator to access a resource group to provision Key Protect.": "Key Protect를 프로비저닝하기 위해 리소스 그룹에 액세스하려면 계정 관리자에게 문의하십시오.",
	"Contact your administrator for access.": "관리자에게 액세스 권한을 문의하십시오.",
	"Contact your administrator for additional assistance.": "추가 지원이 필요하면 관리자에게 문의하십시오.",
	"Container registry": "Container registry",
	Containers: Containers,
	"Copied to clipboard": "클립보드에 복사함",
	"Copy to clipboard": "클립보드에 복사",
	"Cost details": "비용 세부사항",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "가격 정보를 로드할 수 없습니다. 페이지를 새로 고치거나 나중에 다시 시도해 보십시오.",
	Country: Country,
	Create: Create,
	"Create a key": "키 작성",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "신속한 문제 해결 및 사전적 가동 중지 시간 방지를 위해 로그 관리 및 분석을 지원하는 로그 라우팅 대상을 작성하십시오. <a>자세히 알아보기</a>",
	"Create a new instance to get started.": "시작하려면 새 인스턴스를 작성하십시오.",
	"Create a project": "프로젝트 작성",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "Satellite 위치를 작성하여 IBM Cloud를 어디로든 가져오십시오. 자세한 정보는 <a>문서를 참조하십시오.</a>",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "IBM Cloud 활동의 모니터링 및 감사를 지원하려면 보안 및 규정 준수를 강화하기 위해 Activity Tracker 이벤트 라우팅 대상 및 라우트를 작성하십시오. <a>자세히 알아보기</a>",
	"Create an encryption key or import your own key.": "암호화 키를 작성하거나 사용자 고유의 키를 가져오십시오.",
	"Create cluster": "클러스터 작성",
	"Create failed": "작성 실패",
	"Create instance": "인스턴스 작성",
	"Create location": "위치 작성",
	"Create new": "새로 작성",
	"Create new instance": "새 인스턴스 작성",
	"Create new key": "새 키 작성",
	"Create new secret": "새 시크릿 작성",
	"Create reference": "참조 작성",
	"Create resource": "리소스 작성",
	"Create Satellite location": "Satellite 위치 작성",
	"Create secret": "시크릿 작성",
	"Create services": "서비스 작성",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "{{serviceName}}에 의해 생성된 이벤트에 대한 알림을 받으려면 Event Notifications에서 주제, 대상, 구독을 작성하십시오.",
	Created: Created,
	Creating: Creating,
	"Creating ...": "작성 중...",
	"Creating...": "작성 중...",
	Critical: Critical,
	"CRON expression": "Cron 표현식",
	Current: Current,
	Custom: Custom,
	"Custom access": "사용자 정의 액세스 권한",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "데이터 후크 인수 블록",
	"Datahook Params": "데이터 후크 매개변수",
	"Datahook response": "데이터 후크 응답",
	"Day of month": "일",
	"Day of Month (UTC)": "일(UTC)",
	"Day of week": "요일",
	"Day of week (UTC)": "요일(UTC)",
	December: December,
	"Dedicated hosts": "전용 호스트",
	"Default target": "기본 대상",
	"Default title": "기본 제목",
	"Define project details": "프로젝트 세부사항 정의",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "이 이벤트에 의해 생성된 이벤트의 반복되는 타이밍을 정의합니다. 사전 정의된 패턴을 선택하고 필요에 따라 사용자 정의하십시오. 스케줄은 협정 세계시(UTC)로 지정됩니다.",
	"Define the scope of audit events collected": "수집되는 감사 이벤트의 범위 정의",
	Delete: Delete,
	"Delete cluster": "클러스터 삭제",
	"Delete failed": "삭제 실패",
	"Delete retry wait": "삭제 재시도 대기",
	"Delete the persistent storage used by this cluster": "이 클러스터에서 사용하는 지속적 스토리지 삭제",
	Deleting: Deleting,
	"Deleting...": "삭제 중...",
	"Deploy failed": "배치에 실패함",
	"Deploy retry wait": "배치 재시도 대기",
	Deploying: Deploying,
	"Deployment ready": "배치 준비 완료",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "더 이상 사용되지 않는 버전입니다. 지원이 {{when}}에 종료됩니다. 계속 지원을 받으려면 버전을 업데이트하십시오.",
	"Description (optional)": "설명(선택사항)",
	"Description of the source": "소스에 대한 설명",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "Event Notifications 연결 끊기",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "DNS 하위 도메인 레이블은 {{maxLength}}자 이하여야 합니다.",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "편집 완료",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "업데이트 중에 클러스터 마스터, 작업자 노드, 앱 및 리소스가 계속 실행됩니다. 업데이트가 완료된 후 작업자 노드 버전을 업데이트할 수 있습니다. 지시사항과 버전 간 차이점에 대한 자세한 정보는 <a>문서를 검토하십시오</a>.",
	Edit: Edit,
	"Edit activity tracker integration": "Activity Tracker 통합 편집",
	"Edit Array": "배열 편집",
	"Edit columns": "열 편집",
	"Edit configuration": "구성 편집",
	"Edit details": "세부사항 편집",
	"Edit JSON": "JSON 편집",
	"Edit logging integration": "로깅 통합 편집",
	"Edit secure value": "보안 값 편집",
	"Edit tags": "태그 편집",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "Event Notifications 서비스 인스턴스를 연결하여 {{serviceName}} 인스턴스에 대한 라이프사이클 알림을 사용으로 설정하십시오.",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "감독, 규제 준수를 사용으로 설정하고 IBM Cloud 계정을 관리하기 위한 오퍼레이션 및 위험을 감사합니다.",
	Encryption: Encryption,
	"Encryption key associated": "암호화 키 연관됨",
	"Encryption options menu": "암호화 옵션 메뉴",
	End: End,
	"End date": "종료 날짜",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "통합과의 Schematics 경험을 개선합니다. 아래 옵션 중 하나를 선택하여 지금 통합 추가를 시작하십시오.",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "배치 가능한 아키텍처의 구성 이름을 입력합니다.  예: production-vpc",
	"Enter a password": "비밀번호 입력",
	"Enter a valid CRN": "유효한 CRN 입력",
	"Enter array values. Quotations are added to values after you save.": "배열 값을 입력하십시오. 저장 후 견적이 값에 추가됩니다.",
	"Enter name and description": "이름 및 설명 입력",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "호스트 구역의 이름을 입력하십시오. 고가용성을 위해 인프라 제공자 구역을 기반으로 이 세 구역에 호스트를 할당하십시오. <a>구역이 필요한 이유</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "쉼표로 구분된 네임스페이스를 입력하십시오. 추가를 클릭하면 새 네임스페이스가 목록에 포함되고 자동으로 선택됩니다.",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "쉼표로 구분된 프로젝트를 입력하십시오. 추가를 클릭하면 새 프로젝트가 목록에 포함되고 자동으로 선택됩니다.",
	"Enter source name": "소스 이름 입력",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "Cloud Object Storage 인스턴스에서 기존 버킷의 정확한 이름을 입력하십시오. 이름을 입력하지 않으면 새 버킷이 작성됩니다.",
	Enterprise: Enterprise,
	"Entire secret": "전체 시크릿",
	"Environment (optional)": "환경 (선택사항)",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "환경은 관련 구성에서 공유되는 특성을 포함할 수 있습니다. 구성 내에서 환경이 제공하는 값을 대체할 수 있습니다. <a>자세히 알아보기</a>",
	"Error": "오류",
	"Error checking existing services status": "기존 서비스 상태를 확인하는 중에 오류 발생",
	"Error checking host status": "호스트 상태를 확인하는 중에 오류 발생",
	"Error checking storage status": "스토리지 상태를 확인하는 중에 오류 발생",
	"Error fetching tags": "태그를 페치하는 중에 오류 발생",
	"Error icon": "오류 아이콘",
	"Error loading accounts": "계정 로드 중 오류 발생",
	"Error loading categories": "카테고리 로드 중 오류 발생",
	"Error loading groups": "그룹 로드 중 오류 발생",
	"Error loading instances": "인스턴스 로드 중 오류 발생",
	"Error loading keys": "키 로드 중 오류 발생",
	"Error loading pricing": "가격 로드 중 오류 발생",
	"Error loading properties": "특성 로드 중 오류 발생",
	"Error loading providers": "제공자 로드 중 오류 발생",
	"Error loading regions": "지역 로드 중 오류 발생",
	"Error loading resource groups": "리소스 그룹 로딩 중에 오류 발생",
	"Error loading S2S auth": "S2S 인증을 로드하는 중에 오류 발생",
	"Error loading secrets": "시크릿 로드 중 오류 발생",
	"Error loading source names": "소스 이름 로드 중 오류 발생",
	"Error loading sources": "소스 로드 중 오류 발생",
	"Error loading types": "유형 로드 중 오류 발생",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "이 코드의 유효성을 검증하는 중에 오류가 발생했습니다. 프로모션 코드에 인용 부호가 포함되어 있지 않은지 확인하십시오.",
	Establish: Establish,
	"Estimate costs": "비용 추정",
	"Estimated cost per instance": "인스턴스당 추정 비용",
	"Estimated starting cost": "예상되는 시작 비용",
	"Estimated total ({{count}} instances)": "예상 총계({{count}}개 인스턴스)",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Event Notifications 인스턴스",
	"Event Notifications service instance": "Event Notifications 서비스 인스턴스",
	"Event Source Manager": "이벤트 소스 관리자",
	"Every 2 hours": "2시간마다",
	"Every 2 minutes": "2분마다",
	"Every 3 hours": "3시간마다",
	"Every 4 hours": "4시간마다",
	"Every 5 minutes": "5분마다",
	"Every 6 hours": "6시간마다",
	"Every 10 minutes": "10분마다",
	"Every 15 minutes": "매 15분마다",
	"Every day": "매일",
	"Every fifth day": "5일마다",
	"Every fourth day": "4일마다",
	"Every fourth month": "4개월마다",
	"Every hour": "매시간",
	"Every minute": "매분",
	"Every month": "매달",
	"Every second day": "2일마다",
	"Every second month": "2개월마다",
	"Every sixth month": "6개월마다",
	"Every third day": "3일마다",
	"Every third month": "3개월마다",
	"Examples: access:dev, proj:version-1": "예: access:dev, proj:version-1",
	"Examples: env:dev, version-1": "예: env:dev, version-1",
	"Existing instance": "기존 인스턴스",
	"Exiting encryption selection": "암호화 선택 종료",
	"Expand all rows": "행 모두 펼치기",
	"Expand group": "그룹 펼치기",
	"Expand row": "행 펼치기",
	"Expand summary": "요약 펼치기",
	Expired: Expired,
	"Expired (beta)": "만료됨(베타)",
	"Expires {{when}}": "{{when}}에 만료됨",
	"Expires after beta": "베타 이후 만료됨",
	"Extra large (64px)": "초대형(64px)",
	"Extra small (24px)": "초소형(24px)",
	Failed: Failed,
	"Failed to check permission": "권한 확인 실패",
	"Failed to create configuration": "구성 작성 실패",
	"Failed to create key": "키 작성 실패",
	"Failed to create policy": "정책 작성 실패",
	"Failed to create project": "프로젝트 작성 실패",
	"Failed to fetch": "페치 실패",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "IBM Cloud Activity Tracker 인스턴스 페치에 실패했습니다.",
	"Failed to fetch IBM Cloud Monitoring instances.": "IBM Cloud Monitoring 인스턴스 페치에 실패했습니다.",
	"Failed to fetch IBM Log Analysis instances.": "IBM Log Analysis 인스턴스 페치에 실패했습니다.",
	"failure state": "실패 상태",
	February: February,
	"Fetch data": "데이터 페치",
	Filter: Filter,
	"Filter instance by region": "지역별로 인스턴스 필터링:",
	"Filter...": "필터...",
	Filters: Filters,
	"Filters:": "필터:",
	Finalizing: Finalizing,
	"Finalizing cluster...": "클러스터 완료 중...",
	"Finalizing workers...": "작업자 완료 중...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "IBM Cloud Activity Tracker를 사용하여 클라우드 리소스의 작동에 대한 가시성을 확보하십시오.",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "IBM Cloud Monitoring을 사용하여 클라우드 리소스의 작동에 대한 가시성을 확보하십시오.",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "IBM Log Analysis를 사용하여 클라우드 리소스의 작동에 대한 가시성을 확보하십시오.",
	"Get started": "시작하기",
	"Get started with Security and Compliance Center": "Security and Compliance Center 시작하기",
	"Give your key an alias for easy retrieval later.": "나중에 쉽게 검색할 수 있도록 키에 별명을 지정하십시오.",
	"Helm catalog": "Helm 카탈로그",
	Help: Help,
	"Hide password": "비밀번호 숨기기",
	"Host usage\n(used / total)": "호스트 사용량(사용됨 / 총계)",
	"Hosts needed": "호스트 필요",
	"Hosts requirements met": "호스트 요구사항 충족됨",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "시간(UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "내 토큰을 사용하여 나를 대신하여 소스 서비스 {{sourceServiceDisplayName}}과(와) 대상 서비스 {{serviceDisplayName}} 간의 서비스 간 정책을 작성하는 데 동의합니다.",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "{{instance}}에서 플랫폼 로그 수신을 중지하려고 합니다.",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "{{instance}}에서 플랫폼 메트릭 수신을 중지하려고 합니다.",
	"IaaS ready": "IaaS 준비",
	IAM: IAM,
	"IAM credentials": "IAM 인증 정보",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "ID: {{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "키 링을 지정하지 않으면 기본 키 링에 키가 추가됩니다.",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "선택하면 배열이 \"__NOT_SET__\" 문자열로 저장됩니다.",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "초기 값이 유효한 문자열 배열이 아니면, 비어 있거나 단일 항목 배열이 아래에 표시됩니다.",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "사용자 태그가 비용 청구와 관련된 경우 다음과 같이 키:값 쌍으로 태그를 작성해 보십시오.",
	Images: Images,
	"Import your own key": "자체 키 가져오기",
	"In progress": "진행 중",
	"in progress state": "진행 중 상태",
	Inactive: Inactive,
	"inactive state": "비활성 상태",
	Incomplete: Incomplete,
	"incomplete state": "불완전 상태",
	Information: Information,
	"information state": "정보 상태",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "인프라 구역",
	Instance: Instance,
	"Instance ID": "인스턴스 ID",
	"Instance location": "인스턴스 위치",
	"Instance name": "인스턴스 이름",
	"Instance(s) in {{region}}": "{{region}}의 인스턴스",
	"Instance(s) in region": "지역에 있는 인스턴스",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "내부 서버 오류입니다. 잠시 기다린 후 조치를 다시 시도하십시오. 문제가 지속되면 지원 티켓을 여십시오.",
	"Interpolated URI": "보간된 URI",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "올바르지 않은 데이터 후크 오브젝트, 마지막 올바른 옵션 사용",
	"Invalid label name.": "레이블 이름이 유효하지 않습니다.",
	"Invalid label prefix or name.": "레이블 접두부 또는 이름이 유효하지 않습니다.",
	"Invalid label value.": "레이블 값이 유효하지 않습니다.",
	"Items per page:": "페이지당 항목 수",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "키 별명",
	"Key CRN": "키 CRN",
	"Key description": "키 설명",
	"Key description must be at least 2 characters and no more than 240 characters.": "키 설명은 2자 이상 240자 이하여야 합니다.",
	"Key ID": "키 ID",
	"Key management": "키 관리",
	"Key management service": "키 관리 서비스",
	"Key material": "키 자료",
	"Key material is required to import a key": "키를 가져오려면 키 자료가 필요함",
	"Key material length must be 128, 192, or 256 bits": "키 자료 길이는 128, 192 또는 256비트여야 함",
	"Key material must be base64": "키 자료는 base64여야 함",
	"Key name": "키 이름",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Key Protect 인스턴스 이름",
	"Key ring": "키 링",
	"Key value": "키 값",
	"Label must be of the form 'key:value'.": "레이블은 '키:값' 양식이어야 합니다.",
	"Label name must be no more than {{maxLength}} characters.": "레이블 이름은 {{maxLength}}자 이하여야 합니다.",
	"Label prefix must be a valid DNS subdomain.": "레이블 접두부는 유효한 DNS 하위 도메인이어야 합니다.",
	"Label prefix must be no more than {{maxLength}} characters.": "레이블 접두부는 {{maxLength}}자 이하여야 합니다.",
	"Label value must be no more than {{maxLength}} characters.": "레이블 값은 {{maxLength}}자 이하여야 합니다.",
	"Large (48px)": "대형(48px)",
	"Last modified": "마지막 수정 날짜",
	"Last scanned": "마지막 스캔 날짜",
	"Last updated": "마지막 업데이트 날짜",
	Launch: Launch,
	"Launch activiting tracking": "활성화 추적 실행",
	"Launch in new window": "새 창에서 실행",
	"Launch logging": "로깅 시작",
	"Launch monitoring": "모니터링 시작",
	"Learn more": "자세한 정보",
	"learn more.": "자세히 알아보기.",
	"Learn more.": "자세히 알아보기",
	"List of actions": "조치 목록",
	"list of code sample types": "코드 샘플 유형 목록",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "로딩 표시기",
	"Loading...": "로드 중...",
	"Locate by CRN within your account": "계정 내 CRN으로 찾기",
	Location: Location,
	"Location summary": "위치 요약",
	"Location:": "위치:",
	Locations: Locations,
	"Log collection is already enabled for this resource": "이 리소스에 대해 로그 콜렉션이 이미 사용으로 설정되어 있음",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "이 리소스에 대해 로그 콜렉션이 사용으로 설정되어 있으며 라우팅 구성에 정의된 대로 대상에 전송됩니다.",
	Logging: Logging,
	"Logging (error)": "로깅(오류)",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "최적의 문제 해결과 가동 중지 시간 감소를 위해 로깅이 권장됨",
	"Logging...": "로깅...",
	London: London,
	"Looking for valid service to service authorization policy...": "유효한 서비스 대 서비스 권한 부여 정책을 찾고 있습니다...",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "정책을 작성하는 데 필요한 권한이 누락된 것 같습니다. 계정 관리자에게 문의",
	"Looks like you don't have access to view account information.": "계정 정보를 볼 수 있는 액세스 권한이 없는 것 같습니다.",
	"Looks like you don't have access to view the billing period": "청구 기간을 볼 수 있는 액세스 권한이 없음",
	"Looks like you don't have any scans": "스캔이 없음",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "이 정보를 보는 데 필요한 액세스 권한이 없습니다. 계정 관리자에게 문의하여 권한을 확인하십시오.",
	"Looks like you don't have the correct access": "올바른 접근 권한을 가지고 있지 않은 것 같습니다.",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "올바른 액세스 권한이 없는 것으로 보입니다. 서비스 간 권한 부여를 작성하려면 대상 서비스에 대한 액세스 권한이 있어야 합니다.",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "Event Notifications에 주제, 등록, 대상이 설정되어 있는지 확인하십시오.",
	"Manage encryption by enabling a key management service (KMS).": "키 관리 서비스(KMS)를 사용으로 설정하여 암호화를 관리하십시오.",
	"Manage routing": "라우팅 관리",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "IBM Cloud 리소스, 서비스 및 애플리케이션에 사용되는 암호화 키의 라이프사이클을 관리합니다.",
	"Managed from": "관리 시작",
	March: March,
	May: May,
	"Media gallery video": "미디어 갤러리 비디오",
	"Medium (40px)": "중형(40px)",
	"Metadata location": "메타데이터 위치",
	Metro: Metro,
	"Minimum host requirements are met.": "최소 호스트 요구사항이 충족되었습니다.",
	Minute: Minute,
	"Minute (UTC)": "분(UTC)",
	"Missing prerequisite services": "전제조건 서비스 누락",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "여기서 데이터 후크에 전달된 인수를 수정하십시오.",
	"Mon-Fri": "월-금",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "스캔을 설정하여 모든 환경의 준수 여부를 모니터하십시오.",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "보안 및 규정 준수를 강화하기 위해 IBM Cloud 활동을 모니터링하고 감사합니다. <a>자세히 알아보기</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "월(UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "이름이 이미 사용 중입니다. 고유한 이름을 제공하십시오.",
	"Name must be between 2 and 90 characters": "이름은 2~90자 사이여야 함",
	"Name this project": "프로젝트 이름 지정",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "새 인스턴스",
	Next: Next,
	"Next page": "다음 페이지",
	"Next: Customize": "다음: 사용자 정의",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "사용 가능한 카탈로그 지역 없음",
	"No Cloud Object Storage instance is available.": "사용 가능한 Cloud Object Storage 인스턴스가 없습니다.",
	"No code preview has been configured for terraform. Please visit our docs to ": "Terraform에 대해 코드 미리보기가 구성되지 않았습니다. 다음 문서를 방문하십시오. ",
	"No configurations available": "사용 가능한 구성 없음",
	"No events can be scheduled with your selected CRON expression.": "선택한 CRON 표현식으로 이벤트를 스케줄링할 수 없습니다.",
	"No Hyper Protect Crypto Services instances found": "Hyper Protect Crypto Services 인스턴스를 찾을 수 없음",
	"No instances found": "인스턴스를 찾을 수 없음",
	"No item matches the filters. Clear the filters and try again.": "필터와 일치하는 항목이 없습니다. 필터를 지우고 다시 시도하십시오.",
	"No items available to display. Select an instance and bucket to view objects.": "표시할 수 있는 항목이 없습니다. 오브젝트를 보려면 인스턴스 및 버킷을 선택하십시오.",
	"No items match the current filter.": "현재 필터와 일치하는 항목이 없습니다.",
	"No keys available": "사용 가능한 키 없음",
	"No matches found. To create new tags, contact your tag administrator.": "일치 항목을 찾을 수 없습니다. 새 태그를 작성하려면 태그 관리자에게 문의하십시오.",
	"No matching options": "일치하는 옵션 없음",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "이 계정에 사용 가능한 일치하는 지역 ID가 없습니다. 오류라고 생각되면 페이지를 새로 고치거나 관리자에게 문의하십시오.",
	"No plans found": "플랜을 찾을 수 없습니다.",
	"No regions available": "사용 가능한 지역이 없음",
	"No resource groups available": "사용 가능한 리소스 그룹 없음",
	"No secret available": "사용 가능한 시크릿 없음",
	"No secret group available": "사용 가능한 시크릿 그룹 없음",
	"No service instance available": "사용 가능한 서비스 인스턴스 없음",
	"No valid version update options are available.": "올바른 버전 업데이트 옵션을 사용할 수 없습니다.",
	"Non-compliant": "비준수",
	None: None,
	"None available": "없음",
	Normal: Normal,
	"Normal (48px)": "보통(48픽셀)",
	"Not authorized": "권한이 부여되지 않음",
	"Not ready": "준비되지 않음",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "오브젝트",
	"Object storage": "오브젝트 스토리지",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "Object Storage는 위치 관련 데이터와 위치의 클러스터에 대한 백업을 저장하는 데 사용됩니다. <a>자세히 보기</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "하루에 한 번",
	"Once a month": "한 달에 한 번",
	"Once a week": "일주일에 한 번",
	"Once a year": "1년에 한 번",
	Open: Open,
	"Open dashboard": "대시보드 열기",
	"Open Dashboard": "대시보드 열기",
	"Open menu": "메뉴 열기",
	"Open page navigation menu": "페이지 탐색 메뉴 열기",
	"Open reference picker": "참조 선택기 열기",
	"Open tab list": "탭 목록 열기",
	Osaka: Osaka,
	"Overflow menu": "오버플로우 메뉴",
	"Overflow Menu": "오버플로우 메뉴",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "페이지 {{pageNumber}}",
	"Page Navigation": "페이지 탐색",
	"Page navigation menu": "페이지 탐색 메뉴",
	"Page number": "페이지 번호",
	Pattern: Pattern,
	"Pay-As-You-Go": "종량과금제",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "플랫폼 액세스",
	"Platform logs from {{region}} will be sent to a new instance": "{{region}}의 플랫폼 로그가 새 인스턴스로 전송됨",
	"Platform logs from {{region}} will be sent to an existing instance": "{{region}}의 플랫폼 로그가 기존 인스턴스로 전송됨",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "{{region}}의 플랫폼 로그가 대상 인스턴스로 전송됩니다. <a>자세히 알아보기</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "플랫폼 로그는 정의된 라우팅 범위에 따라 활성화된 IBM Cloud 서비스에서 수집됩니다.",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "프로모션 코드를 적용하기 전 작성하려면 <a>가입</a>하거나 <a>로그인</a>하십시오.",
	"Prefix filter": "접두부 필터",
	Premium: Premium,
	"Preparing master, workers...": "마스터인 작업자 준비 중...",
	"Preparing master...": "마스터 준비 중...",
	"Prerequisite services installed": "전제조건 서비스 설치됨",
	Previous: Previous,
	"Previous page": "이전 페이지",
	"Pricing Plans": "가격 플랜",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "키에 대한 자세한 설명을 제공하십시오. 개인정보를 보호하려면 이름 또는 위치와 같은 개인 데이터를 설명으로 사용하지 마십시오. 키 작성 후에는 이를 변경할 수 없습니다.",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "IBM Cloud 기반 리소스 애플리케이션의 성능 및 상태에 대한 가시성을 제공합니다.",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "적용할 준비가 되셨습니까?",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "Cloud Object Storage 인스턴스 새로 고치기",
	"Refresh data": "데이터 새로 고치기",
	"Refresh secrets": "시크릿 새로 고치기",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "정렬 제거",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "예기치 않은 자원 변경을 방지하기 위해 수정 후크 렌더링이 지원되지 않습니다.",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "작성 요청 중...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "필터 재설정",
	"Reset to default": "기본값으로 재설정",
	"Reset zoom": "확대/축소 재설정",
	"Resource Configuration": "리소스 구성",
	"Resource group": "리소스 그룹",
	"Resource group:": "리소스 그룹:",
	"Resource list": "리소스 목록",
	"Resource List": "자원 목록",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "비용에 포함되지 않는 자원",
	"Restricted access": "제한된 액세스",
	Results: Results,
	"Retrying delete": "삭제 재시도 중",
	"Retrying deploy": "배치 재시도 중",
	"Revert {{resetCount}} to default": "{{resetCount}}을(를) 기본값으로 되돌리기",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "{{resourceDisplayName}}에 대한 액세스 권한 지정 검토",
	"Review settings in Event Notifications": "Event Notifications의 설정 검토",
	"Review the following access group policies to ensure you're assigning the right level of access.": "다음 액세스 그룹 정책을 검토하여 올바른 레벨의 액세스 권한을 지정하고 있는지 확인하십시오.",
	"Rotation interval": "순환 간격",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "순환 정책은 자동 키 순환 사이의 간격을 결정합니다. 예를 들어, 한 달 간격은 키가 30일마다 순환됨을 의미합니다. 정책이 이미 사용 가능한 경우, 이는 이 인스턴스에 대한 인스턴스 정책이 존재함을 의미하며 다른 조치가 수행되지 않으면 표시된 순환 간격이 키에 적용됩니다. 사용 안함으로 설정된 경우에는 이를 사용으로 설정하여 이 키에 대한 정책을 설정하십시오.",
	"Rotation policy": "순환 정책",
	"Rotation policy disabled": "회전 정책 사용 안함",
	"Route name": "라우트 이름",
	Routing: Routing,
	"Routing scope": "라우팅 범위",
	"Row height": "행 높이",
	"Sample not yet available": "샘플을 아직 사용할 수 없음",
	"Sao Paulo": "상파울루",
	"Sat-Sun": "토-일",
	Satellite: Satellite,
	"Satellite container": "Satellite 컨테이너",
	"Satellite location": "Satellite 위치",
	"Satellite location base cost": "Satellite 위치 기반 비용",
	"Satellite location base functionality": "Satellite 위치 기본 기능",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "저장 중...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "Schematics 작업공간 및 기타 프로젝트 데이터는 선택한 영역 및 자원 그룹에 저장됩니다. <a>자세히 보기</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "Schematics 작업공간은 이 영역에서 프로비저닝됩니다. 프로젝트는 여전히 모든 영역에 자원을 배치할 수 있습니다.",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "Schematics 작업공간은 이 자원 그룹에서 프로비저닝됩니다. 프로젝트는 여전히 모든 리소스 그룹에 자원을 배치할 수 있습니다.",
	Search: Search,
	"Search in this instance": "이 인스턴스에서 검색",
	Secret: Secret,
	"Secret configured": "구성된 시크릿",
	"Secret group": "시크릿 그룹",
	"Secret type": "시크릿 유형",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "보안 값",
	"See details": "세부사항 참조",
	Select: Select,
	"Select a location to see what steps you need to take next.": "다음에 수행해야 하는 단계를 확인할 위치를 선택하십시오.",
	"Select a project": "프로젝트 선택",
	"Select a reference": "참조 선택",
	"Select a region": "지역을 선택하십시오.",
	"Select a resource group": "리소스 그룹 선택",
	"Select a role to determine the level of access for the source service.": "역할을 선택하여 소스 서비스에 대한 액세스 레벨을 결정합니다.",
	"Select a secret": "시크릿 선택",
	"Select a secret group": "시크릿 그룹 선택",
	"Select a service instance": "서비스 인스턴스 선택",
	"Select all {{totalRowCount}} items": "모든 {{totalRowCount}}개 항목 선택",
	"Select all rows on page": "페이지의 모든 행 선택",
	"Select an environment": "환경 선택",
	"Select an existing configuration": "기존 구성 선택",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "플랫폼 메트릭을 수신할 IBM Cloud Monitoring 인스턴스 선택",
	"Select an IBM Log Analysis instance to receive platform logs": "플랫폼 로그를 수신할 IBM Log Analysis 인스턴스 선택",
	"Select an instance": "인스턴스 선택",
	"Select an instance to show keys": "키를 표시할 인스턴스 선택",
	"Select an option...": "옵션 선택...",
	"Select existing key": "기존 키 선택",
	"Select from Secrets Manager": "시크릿 관리자에서 선택",
	"Select KMS instance": "KMS 인스턴스 선택",
	"Select namespaces": "네임스페이스 선택",
	"Select one or more namespaces": "하나 이상의 네임스페이스 선택",
	"Select one or more projects": "하나 이상의 프로젝트 선택",
	"Select prerequisites": "전제조건 선택",
	"Select projects": "프로젝트 선택",
	"Select region and resource group": "지역 및 리소스 그룹 선택",
	"Select row": "행 선택",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "낮은 네트워크 대기 시간을 보장하기 위해 인프라가 상주하는 위치에 가장 가까운 <a>IBM Cloud 지역</a>을 선택하십시오.",
	"Select the following tile to deploy it.": "다음 타일을 선택하여 배치하십시오.",
	"Send all audit events from enabled resources in {{region}}.": "{{region}}의 활성화된 리소스에서 모든 감사 이벤트를 전송하십시오.",
	"Send all available audit events in this account.": "이 계정에서 사용 가능한 모든 감사 이벤트를 전송하십시오.",
	"Send events to": "다음 주소로 이벤트 보내기",
	"Send logs to": "다음 주소로 로그 보내기",
	"Send test notification": "테스트 알림 보내기",
	Sending: Sending,
	"Sent!": "전송되었습니다!",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "서버리스 프로젝트",
	Service: Service,
	"Service access": "서비스 액세스",
	"Service authorization": "서비스 권한",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "Activity Tracker 이벤트 라우팅이 클라우드 로그와 통신할 수 있도록 하려면 서비스 권한이 필요합니다. 이 계정의 모든 클라우드 로그 리소스로 범위가 지정된 정책을 작성하려면 <span>지금 권한 부여</span>를 클릭하십시오.",
	"Service authorization required": "서비스 권한 필수",
	"Service instance": "서비스 인스턴스",
	"Service name": "서비스 이름",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "인스턴스에 대한 서비스 대 서비스 권한이 제공되어야 합니다. <a>자세히 알아보기</a>",
	"Service to service authorization policy found": "서비스 간 서비스 권한 부여 정책 발견",
	"Service to service authorization policy needed": "서비스 간 권한 부여 정책 필요",
	"Service type": "서비스 유형",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "서비스 대 서비스 권한을 확인할 수 없습니다. 필요한 역할을 수동으로 추가하고 확인하십시오.",
	"Service-to-service authorization requirements are met.": "서비스 대 서비스 권한 요구사항이 충족되었습니다.",
	"Set an interval (in months)": "간격 설정(월)",
	"Set key rotation policy": "키 순환 정책 설정",
	"Set up auth": "인증 설정",
	Settings: Settings,
	"Short (32px)": "낮음(32픽셀)",
	"Show all filters": "모든 필터 표시",
	"Show code sample": "코드 샘플 표시",
	"Show environments information": "환경 정보 표시",
	"Show error information": "오류 정보 표시",
	"Show information": "정보 표시",
	"Show less": "간단히 표시",
	"Show more": "자세히 표시",
	"Show more details": "세부사항 표시",
	"Show password": "비밀번호 표시",
	"Show tooltip": "도구 팁 표시",
	"Showing {{count}} item": "{{count}}개 항목 표시",
	"Showing {{count}} items": "{{count}}개 항목 표시",
	Size: Size,
	"Small (32px)": "소형(32px)",
	"Some events from {{serviceName}}:": "{{serviceName}}의 일부 이벤트:",
	"Something went wrong": "문제가 발생함",
	"Something went wrong.": "문제가 발생했습니다.",
	"Something went wrong. Try reloading the page to see this information": "문제가 발생했습니다. 이 정보를 보려면 페이지를 다시 로드하십시오.",
	Sort: Sort,
	"Sort ascending": "오름차순 정렬",
	"Sort descending": "내림차순 정렬",
	Source: Source,
	"Source Details": "소스 세부사항",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "서비스의 소스가 Event Notifications 인스턴스에 존재하지 않습니다. 관리자에게 문의하십시오.",
	"Source service": "소스 서비스",
	"Specific namespaces not supported": "특정 네임스페이스가 지원되지 않음",
	"Specific projects not supported": "특정 프로젝트가 지원되지 않음",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "먼저 워크로드를 실행하기에 적합한 클러스터를 작성하십시오.",
	"Start date": "시작 날짜",
	"Starting at": "시작 시간",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "시작 비용은 이 리소스 구성을 기준으로 합니다. 이 제품을 프로젝트에 추가한 후 구성을 편집할 수 있으며, 이는 비용에 영향을 줄 수 있습니다.",
	State: State,
	Status: Status,
	"status icon": "상태 아이콘",
	"Stay in pattern": "패턴 유지",
	"Steps complete": "단계 완료",
	Storage: Storage,
	"Storage bucket (optional)": "스토리지 버킷(선택사항)",
	"Storage configuration missing": "스토리지 구성 누락",
	"Storage ready": "스토리지 준비됨",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "IBM Cloud 로깅 데이터 및 이벤트를 저장, 검색, 분석, 모니터, 경고하십시오.",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "성공 상태",
	"Success! This promotion was applied to your account.": "성공! 이 프로모션이 계정에 적용되었습니다.",
	"Successfully created new Key Protect instance": "새 Key Protect 인스턴스 작성 완료",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "지원 플랜",
	"Switch to folders view": "폴더 보기로 전환",
	"Switch to objects view": "오브젝트 보기로 전환",
	Sydney: Sydney,
	"Syntax: ": "구문: ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "이름이 올바르지 않으므로 '{{tagName}}' 태그를 작성할 수 없습니다.",
	tags: tags,
	Tags: Tags,
	"Tags:": "태그:",
	"Tags: (optional)": "태그: (선택사항)",
	"Tall (64px)": "높음(64픽셀)",
	"Target destination": "대상",
	"Target location": "대상 위치",
	"Target name": "대상 이름",
	"Target selected": "대상이 선택됨",
	"Target service instance": "대상 서비스 인스턴스",
	"Target type": "대상 유형",
	"Template error": "템플리트 오류",
	"Terms and conditions": "이용 약관",
	"Test notification": "테스트 알림",
	"The address field is required.": "주소 필드는 필수입니다.",
	"The catalog window might have been blocked from opening.": "카탈로그 창이 열리지 않도록 차단되었을 수 있습니다.",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "연결된 Event Notifications 인스턴스가 계정에서 삭제되었습니다. 알림을 계속 사용하려면 메뉴( ⋮ )에서 연결 끊기를 클릭하여 현재 인스턴스의 연결을 끊은 다음, 다른 Event Notifications 인스턴스를 연결하십시오.",
	"The description should not contain any leading or trailing whitespace characters.": "설명에는 선행 또는 후행 공백 문자가 포함되지 않아야 합니다.",
	"The description should not exceed {{limit}} characters in length.": "설명의 길이는 {{limit}}자를 넘지 않아야 합니다.",
	"The following access is required:": "다음과 같은 액세스 권한이 필요합니다.",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "다음 코드 미리보기는 해당 요청을 CLI 명령으로 표시합니다. 이를 사용자 고유의 자동화를 작성하기 위한 시작점으로 사용하십시오. ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "다음 코드 미리보기는 해당 요청을 REST API 호출로 표시합니다. 이를 사용자 고유의 자동화를 작성하기 위한 시작점으로 사용하십시오. ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "다음 코드 미리보기는 Terraform과 함께 해당 요청을 표시합니다. 이를 사용자 고유의 자동화를 작성하기 위한 시작점으로 사용하십시오. ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "다음 미리보기는 해당 요청을 코드로 표시합니다. 이를 사용자 고유의 자동화를 작성하기 위한 시작점으로 사용하십시오.",
	"The following resources were not included in the cost estimate but might have an associated cost.": "다음 자원은 비용 추정에 포함되지 않았지만 연관된 비용이 있을 수 있습니다.",
	"The IAM role manager for {{serviceName}}": "{{serviceName}}에 대한 IAM 역할 관리자",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "서비스 대 서비스 권한이 계정에서 제거되었으므로 해당 인스턴스에 액세스할 수 없습니다. {{sourceServiceName}}과(와) Event Notifications 사이에 이벤트 소스 관리자 액세스 권한이 있는 권한을 작성하십시오.",
	"The list of namespaces can't be populated. Try again later.": "네임스페이스 목록을 채울 수 없습니다. 나중에 다시 시도하십시오.",
	"The list of projects can't be populated. Try again later.": "프로젝트 목록을 채울 수 없습니다. 나중에 다시 시도하십시오.",
	"The name is required.": "이름은 필수입니다.",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "이름은 {{max}}자 미만이어야 하고, 문자로 시작하며 영숫자 문자와 '-', '.'만 포함할 수 있습니다.",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "네임스페이스의 이름에는 소문자, 숫자 및 대시만 포함될 수 있습니다. 이 이름은 대시로 시작되거나 끝나서는 안되며 최대 63자여야 합니다.",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "프로젝트의 이름에는 소문자, 숫자 및 대시만 포함될 수 있습니다. 이 이름은 대시로 시작되거나 끝나서는 안되며 최대 63자여야 합니다.",
	"The name should contain only alphanumeric, underscore, dashes and space.": "이름에는 영숫자, 밑줄, 대시 및 공백만 사용할 수 있습니다.",
	"The name should not contain any special characters.": "이름에 특수 문자를 사용할 수 없습니다.",
	"The name should not exceed {{limit}} characters in length.": "이름은 길이가 {{limit}}자를 초과해서는 안 됩니다.",
	"The region is required.": "지역은 필수입니다.",
	"The resource group is required.": "자원 그룹은 필수입니다.",
	"The resource group window might have been blocked from opening.": "자원 그룹 창이 열리지 않도록 차단되었을 수 있습니다.",
	"The tag name must be in a key:value format": "태그 이름의 형식은 키:값이어야 함",
	"The tag name must be in a key:value format.": "태그 이름은 키:값 형식이어야 합니다.",
	"The window might have been blocked from opening.": "창이 열리지 않도록 차단되었을 수 있습니다.",
	"There was a problem loading resource groups.": "리소스 그룹을 로드하는 중에 문제가 발생했습니다.",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "이러한 역할은 서비스를 사용하거나 서비스 API 호출을 수행할 수 있게 해 줍니다. 각 역할은 선택된 서비스에 의해 사용자 정의됩니다. 해당되는 항목을 모두 선택하십시오. 세부사항은 서비스의 문서를 참조하십시오.",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "이 역할은 서비스에 지정되는 액세스 방식을 사용자 정의하기 위해 계정의 관리자가 작성합니다. 역할에 대한 조치 아이콘을 클릭하여 이 역할에 맵핑되는 조치를 검토하십시오.",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "이러한 역할은 플랫폼 리소스에 대해 인스턴스 작성, 앱에 인스턴스 연결, 사용자 액세스 지정과 같은 조치를 수행할 수 있게 해 줍니다. 해당되는 항목을 모두 선택하십시오.",
	"This field is required": "이 필드는 필수입니다.",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "이는 현재 제출 시 전송되지 않으며 API를 담당하는 팀의 업데이트를 보류 중입니다.",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "{{serviceName}} 인스턴스가 Event Notifications에서 참조되는 방식은 다음과 같습니다.",
	"This project name \"{{name}}\" already exists, please choose another name.": "이 프로젝트 이름 \"{{name}}\"이(가) 이미 존재하므로 다른 이름을 선택하십시오.",
	"This section is under construction, come back later.": "이 섹션은 현재 구성 중입니다. 나중에 다시 돌아오십시오.",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "이 서비스에는 클러스터에 할당된 추가 스토리지가 필요합니다. 일치하는 스토리지 구성이 없습니다.",
	"This tag already exists. Choose another name for your tag.": "이 태그는 이미 있습니다. 태그에 다른 이름을 선택하십시오.",
	"This value already exists.": "이 값이 이미 있습니다.",
	"This view is not available for some account types": "일부 계정 유형에는 이 보기를 사용할 수 없습니다.",
	"Three zone names are required": "세 개의 구역 이름이 필요함",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "HPCS 암호화를 추가하려면 다음 단계를 따르십시오.",
	"To connect, the instance in this region must be configured for platform": "연결하려면 이 지역의 인스턴스가 플랫폼에 대해 구성되어야 합니다.",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "{{serviceName}}에서 생성된 이벤트의 알림을 제어하려면 Event Notifications 인스턴스에 연결하십시오. <a>자세히 알아보기</a>",
	"To create a new HPCS key, follow the steps below...": "새 HPCS 키를 작성하려면 아래 단계를 따르십시오...",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "총 계정 수",
	"Total estimated cost": "총 예상 비용",
	"Transaction ID": "트랜잭션 ID",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "나중에 다시 시도하거나 계정 관리자에게 문의하십시오.",
	"Try again later.": "나중에 다시 시도하십시오.",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "페이지를 새로 고친 후 조치를 다시 수행하여 문제점이 지속되는지 확인하십시오. 만일 그렇다면, <a>지원되는 브라우저</a>를 사용하고 있는지 확인하고 <a>상태 페이지</a>에서 다른 문제가 있는지 확인하십시오. 여전히 문제가 계속되면 <a>지원</a>에서 도움을 받으십시오.",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "몇 분 동안 기다린 후 조치를 다시 수행하여 문제점이 계속되는지 확인하십시오. 계속되면 <a>상태 페이지</a>에서 상황을 확인하십시오. 여전히 문제가 계속되면 <a>지원</a>에서 도움을 받으십시오.",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "확인하려면 \"{{clusterName}}\" 입력",
	"Type \"{{name}}\" to confirm": "확인하려면 \"{{name}}\" 입력",
	"Unable to configure activity tracker event routing.": "Activity Tracker 이벤트 라우팅을 구성할 수 없습니다.",
	"Unable to configure Activity Tracker integration.": "Activity Tracker 통합을 구성할 수 없습니다.",
	"Unable to configure Logging integration.": "로깅 통합을 구성할 수 없습니다.",
	"Unable to configure logging.": "로깅을 구성할 수 없습니다.",
	"Unable to connect your service to Event Notifications service. Try again later.": "서비스를 Event Notifications 서비스에 연결할 수 없습니다. 나중에 다시 시도하십시오.",
	"Unable to create authorization policy.": "권한 정책을 작성할 수 없습니다.",
	"Unable to create Satellite location": "Satellite 위치를 작성할 수 없음",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "지금은 서비스 대 서비스 정책을 작성할 수 없습니다. 페이지를 새로 고치거나 나중에 다시 시도하십시오.",
	"Unable to delete cluster": "클러스터를 삭제할 수 없음",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "Event Notifications 인스턴스의 연결을 끊을 수 없습니다. 페이지를 새로 고치거나 나중에 다시 시도하십시오.",
	"Unable to get cluster data": "클러스터 데이터를 가져올 수 없음",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "Event Notifications 인스턴스 세부사항을 가져올 수 없습니다. 페이지를 새로 고치거나 나중에 다시 시도하십시오.",
	"Unable to get storage instances.": "스토리지 인스턴스를 가져올 수 없습니다.",
	"Unable to list clusters.": "클러스터를 나열할 수 없습니다.",
	"Unable to list locations.": "위치를 나열할 수 없습니다.",
	"Unable to load Activity Tracker service catalog data": "Activity Tracker 서비스 카탈로그 데이터를 로드할 수 없음",
	"Unable to load Cloud Logs service catalog data": "클라우드 로그 서비스 카탈로그 데이터를 로드할 수 없음",
	"Unable to load cluster details.": "클러스터 세부사항을 로드할 수 없습니다.",
	"Unable to load cluster update version options.": "클러스터 업데이트 버전 옵션을 로드할 수 없습니다.",
	"Unable to load event routing settings": "이벤트 라우팅 설정을 로드할 수 없음",
	"Unable to load event routing target instances": "이벤트 라우팅 대상 인스턴스를 로드할 수 없음",
	"Unable to load event routing target instances.": "이벤트 라우팅 대상 인스턴스를 로드할 수 없습니다.",
	"Unable to load event routing targets": "이벤트 라우팅 대상을 로드할 수 없음",
	"Unable to load event routing targets.": "이벤트 라우팅 대상을 로드할 수 없습니다.",
	"Unable to load IBM Cloud locations data": "IBM Cloud 위치 데이터를 로드할 수 없음",
	"Unable to load logging instances": "로깅 인스턴스를 로드할 수 없음",
	"Unable to load logging instances.": "로깅 인스턴스를 로드할 수 없습니다.",
	"Unable to load logging service catalog data": "로깅 서비스 카탈로그 데이터를 로드할 수 없음",
	"Unable to load logs routing targets": "로그 라우팅 대상을 로드할 수 없음",
	"Unable to load logs routing targets.": "로그 라우팅 대상을 로드할 수 없습니다.",
	"Unable to perform": "수행할 수 없음",
	"Unable to retrieve cluster details": "클러스터 세부사항을 검색할 수 없음",
	"Unable to retrieve data": "데이터를 검색할 수 없음",
	"Unable to retrieve location information.": "위치 정보를 검색할 수 없습니다.",
	"Unable to retrieve project configurations.": "프로젝트 구성을 검색할 수 없습니다.",
	"Unable to send test notification to Event Notifications instance. Try again later.": "Event Notifications 인스턴스에 테스트 알림을 보낼 수 없습니다. 나중에 다시 시도하십시오.",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "Event Notifications 인스턴스에 테스트 알림을 보낼 수 없습니다. 주제가 Event Notifications에 설정되어 있는지 확인하십시오.",
	"Unable to update cluster version.": "클러스터 버전을 업데이트할 수 없습니다.",
	Unknown: Unknown,
	"unknown state": "알 수 없는 상태",
	"Unselect all rows": "모든 행 선택 취소",
	"Unselect row": "행 선택 취소",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "지원되지 않는 버전입니다. 계속 지원을 받으려면 버전을 업데이트하십시오.",
	"Upcoming scheduled events in your timezone": "사용자 시간대에 다가오는 예정된 이벤트",
	Update: Update,
	"Update available": "업데이트 사용 가능",
	"Update cluster version": "클러스터 버전 업데이트",
	"Update tags": "태그 업데이트",
	"Update version": "업데이트 버전",
	"Updating...": "업데이트 중...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "청구 기간을 보려면 계정을 업그레이드하십시오.",
	"Usage based charges apply per gigabyte of audit events ingested.": "수집된 감사 이벤트의 기가바이트당 사용량 기반 요금이 적용됩니다.",
	"Usage based charges apply per gigabyte of logs ingested.": "수집된 로그의 기가바이트당 사용량 기반 요금이 적용됩니다.",
	"Usage costs": "사용 비용",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "인증용 자격 증명을 중앙에서 안전하게 관리하려면 본인확인정보를 사용하십시오. <a>자세히 알아보기</a>",
	"Use a secret?": "본인확인정보 사용?",
	"Use existing": "기존 사용",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "키를 쉽게 식별할 수 있도록 키 별명을 사용하십시오. 키 별명은 고유하며 쉽게 인식할 수 있는 사용자 정의 이름입니다.",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "태그를 사용하여 리소스를 구성하십시오. 사용자 태그가 비용 청구와 관련된 경우 다음과 같이 관련 태그를 그룹화하는 데 도움이 되도록 키:값 쌍으로 태그를 작성해 보십시오.",
	"Use the options below to choose the item that the reference will be created for.": "아래 옵션을 사용하여 참조를 작성할 항목을 선택하십시오.",
	"User evaluation required": "사용자 평가가 필요함",
	"User permissions failure": "사용자 권한 실패",
	"User tags": "사용자 태그",
	"User tags (optional": "사용자 태그(선택사항)",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "사용자 태그는 계정 전체에서 볼 수 있습니다. 태그 이름에 민감한 데이터를 포함하지 마십시오.",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "값은 유효한 배열이어야 합니다(예: [\"배열\"]). 널 배열을 지정하려면 \"__NOT_SET__\"을 사용하십시오.",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "{{missingServices}} 서비스가 해당 위치에 설치되어 있는지 확인하십시오.",
	Version: Version,
	View: View,
	"View all": "모두 보기",
	"View audit events": "감사 이벤트 보기",
	"View docs": "문서 보기",
	"View error information": "오류 정보 보기",
	"View logging": "로깅 보기",
	"View-only mode": "보기 전용 모드",
	"VPC Gen1": "VPC Gen1",
	"VPC Gen2": "VPC Gen2",
	Warning: Warning,
	"warning state": "경고 상태",
	"Washington DC": "워싱턴 DC",
	Wednesday: Wednesday,
	"What you will need:": "필요한 사항은 다음과 같습니다.",
	"What's the purpose of this project?": "이 프로젝트의 목적은 무엇인가요?",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "클러스터를 삭제할 때 모든 작업자 노드, 앱, 컨테이너가 영구적으로 삭제됩니다. 이 조치는 실행 취소할 수 없습니다. 진행하기 전에 필요한 모든 데이터 및 구성 파일을 백업했는지 확인하십시오.",
	"Worker count": "작업자 계수",
	Workloads: Workloads,
	"Wrong Syntax": "잘못된 구문",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "이 이름이 있는 위치가 이미 있습니다. 고유한 이름을 입력합니다.",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "Security and Compliance Center의 인스턴스가 이미 있습니다. 결과를 보려면 첨부 파일을 작성하여 첫 번째 스캔을 스케줄해야 합니다.",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "정책의 리소스에 대한 액세스 레벨로 인해 이 정책을 수정할 수 없습니다. 수정 기능을 원하는 경우 관리자에게 문의하여 리소스 액세스를 업데이트하십시오.",
	"You can find a list of resources here once you create them.": "자원을 작성하면 여기에서 자원 목록을 찾을 수 있습니다.",
	"You can find your resource details here after you create them.": "자원 세부사항을 작성한 후에 여기에서 찾을 수 있습니다.",
	"You can find your resources here after you create them.": "리소스를 작성하고 나면 여기서 찾을 수 있습니다.",
	"You can find your Satellite locations here after you create them.": "위성 위치를 작성한 후에는 여기서 해당 위치를 찾을 수 있습니다.",
	"You do not have access to any resource groups.": "리소스 그룹에 액세스할 수 없습니다.",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "리소스 그룹에 액세스할 수 없습니다. 리소스 그룹을 <a>작성</a>하십시오.",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "태그를 편집할 수 있는 권한이 없습니다. 더 많은 액세스 권한이 필요한 경우 관리자에게 문의하십시오.",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "\"{{project}}\"에 구성을 추가할 수 있는 올바른 액세스 권한이 없음",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "액세스가 제한되어 태그를 추가하거나 제거할 수 없습니다. 더 많은 액세스 권한이 필요한 경우 관리자에게 문의하십시오.",
	"You haven't connected an Event Notifications service instance yet.": "아직 Event Notifications 서비스 인스턴스를 연결하지 않았습니다.",
	"You may also <a>create an instance</a>.": "<a>인스턴스를 작성</a>할 수도 있습니다.",
	"You may also create a new one.": "새로 작성할 수도 있습니다.",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "컨텍스트 기반 제한사항 또는 IAM 정책을 사용할 수 있습니다. 계정 관리자에게 문의하십시오.",
	"You must have at least one active root key. Try creating a new one.": "하나 이상의 활성 루트 키가 있어야 합니다. 새로 작성하십시오.",
	"You need at least 1 topic to send a test notification.": "테스트 알림을 전송하려면 하나 이상의 주제가 필요합니다.",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "이 프로젝트에 대한 IBM Cloud 프로젝트 서비스에서 편집자 또는 관리자 역할이 필요합니다. <a>사용자가 직접 본인에게 액세스 </a>권한을 할당하거나 계정 관리자에게 액세스 권한을 요청하십시오.",
	"You're adding tags to:": "다음에 태그를 추가 중입니다.",
	"You're editing tags for:": "다음에 대한 태그를 편집 중입니다.",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "이 인스턴스에 연결할 수 있는 권한이 없습니다. 권한을 확인하거나 관리자에게 문의하십시오.",
	"You're using the newest version of the API server. There are no updates available at this time.": "새 버전의 API 서버를 사용 중입니다. 현재 사용 가능한 업데이트가 없습니다.",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "한 번에 첨부할 수 있는 최대 태그 수에 도달했습니다. 태그를 더 첨부하려면 먼저 변경사항을 저장하십시오.",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "API 서버가 {{version}} 버전으로 업데이트되고 있습니다. 완료되고 나면 작업자 노드를 동일한 버전으로 업데이트할 수 있습니다.",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "이미지 확대",
	"Zoom out image": "이미지 축소"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, ko as default, hour, hr, mo, more, provided, region, resources, tag, tags };
